import Reveal from "./Reveal";

const STEPS = [
  { label: "Aug 2024", title: "Act passes", pos: 6 },
  { label: "Feb 2025", title: "Banned uses live", pos: 32 },
  { label: "Aug 2, 2026", title: "Annex III enforces", pos: 66, active: true },
  { label: "Aug 2027", title: "Full effect", pos: 94 },
];

export const Timeline = () => (
  <section
    data-testid="section-timeline"
    className="border-t"
    style={{ borderColor: "var(--line)" }}
  >
    <div className="mx-auto max-w-6xl px-6 py-14 md:px-10 md:py-16">
      <Reveal>
        <p className="eyebrow" data-testid="timeline-eyebrow">
          AI Act timeline
        </p>
      </Reveal>

      <div className="mt-9 hidden md:block">
        <div className="relative px-2">
          <div className="timeline-track" />
          {STEPS.map((s, i) => (
            <div
              key={i}
              className={`timeline-dot ${s.active ? "active" : ""}`}
              style={{ left: `${s.pos}%` }}
              data-testid={`timeline-dot-${i}`}
            />
          ))}
        </div>
        <div className="relative mt-5 h-16">
          {STEPS.map((s, i) => (
            <div
              key={i}
              className="absolute -translate-x-1/2"
              style={{ left: `${s.pos}%` }}
              data-testid={`timeline-label-${i}`}
            >
              <p
                className={`whitespace-nowrap text-[12.5px] font-semibold tracking-tight ${
                  s.active ? "" : ""
                }`}
                style={{ color: s.active ? "var(--red)" : "var(--muted-2)" }}
              >
                {s.label}
              </p>
              <p
                className={`whitespace-nowrap text-[13px] ${s.active ? "font-semibold" : ""}`}
                style={{ color: s.active ? "var(--ink)" : "var(--muted)" }}
              >
                {s.title}
              </p>
              {s.active ? (
                <p
                  className="mt-1 whitespace-nowrap text-[11.5px] font-medium"
                  style={{ color: "var(--red)" }}
                  data-testid="timeline-here-marker"
                >
                  ← we are here-ish
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </div>

      {/* Mobile: stacked list */}
      <ol className="mt-7 space-y-4 md:hidden">
        {STEPS.map((s, i) => (
          <li
            key={i}
            className="flex items-start gap-3"
            data-testid={`timeline-mobile-${i}`}
          >
            <span
              className={`mt-1.5 inline-block flex-shrink-0 rounded-full ${
                s.active ? "" : ""
              }`}
              style={{
                width: s.active ? 12 : 8,
                height: s.active ? 12 : 8,
                background: s.active ? "var(--red)" : "#d4d4d4",
                boxShadow: s.active ? "0 0 0 4px rgba(185,28,28,0.12)" : "none",
              }}
              aria-hidden="true"
            />
            <div>
              <p
                className="text-[12px] font-semibold tracking-tight"
                style={{ color: s.active ? "var(--red)" : "var(--muted-2)" }}
              >
                {s.label}
              </p>
              <p
                className={`text-[14.5px] ${s.active ? "font-semibold" : ""}`}
                style={{ color: s.active ? "var(--ink)" : "var(--muted)" }}
              >
                {s.title}
                {s.active ? (
                  <span className="ml-2 text-[12.5px] font-medium" style={{ color: "var(--red)" }}>
                    ← we are here-ish
                  </span>
                ) : null}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default Timeline;
